import React from 'react';
import {Quill} from 'react-quill';

import ReactDOMServer from 'react-dom/server';

// @ts-expect-error - imported from .js/.jsx file
import {PencilToPaperIcon} from 'shells/icon/svg/pencil-to-paper-icon';

const Embed = Quill.import('blots/embed');

export type Placeholder = {
    id: string;
};

// Renders when adding a new custom field merge tag
export class PlaceholderBlotPlaceholder extends Embed {
    static blotName = 'placeholder-blot-placeholder';
    static tagName = 'span';
    static className = 'ql-placeholder-blot-placeholder';

    placeholderValue: Placeholder | null | undefined;

    constructor(domNode: Node, value?: Placeholder) {
        super(domNode, value);
        this.placeholderValue = value;
    }

    static create(value: Placeholder) {
        const node: HTMLElement = super.create(value);
        node.setAttribute('data-id', value.id);
        node.setAttribute('spellcheck', 'false');

        node.innerHTML = ReactDOMServer.renderToStaticMarkup(
            React.createElement(
                'span',
                {className: 'ql-placeholder-content'},
                React.createElement(PencilToPaperIcon, {
                    size: 14,
                    wrapWithDiv: false,
                })
            )
        );

        return node;
    }

    value() {
        return '';
    }

    static value(domNode: HTMLElement) {
        return domNode.dataset;
    }

    length(): number {
        return 1;
    }
}
